export default __webpack_public_path__ + "static/media/Lantern.7455e809.gif";